module.exports = __webpack_public_path__ + "static/media/botIcon.44db02a0.svg";